import { isSupplier } from 'permissions';

import { hasProcessPermission } from 'modules/common/permissions';

import { initSupplierTablesDetailsPage } from './detailsPage/data/sagas';
import SupplierTablesDetailsPage from './detailsPage/entry';
import { initSupplierTablesListPage } from './listPage/data/sagas';
import SupplierTablesListPage from './listPage/entry';

export default [
  {
    exact: true,
    path: '/processes/tables',
    component: SupplierTablesListPage,
    saga: initSupplierTablesListPage,
    permissions: [isSupplier, hasProcessPermission],
  },
  {
    exact: true,
    path: '/processes/tables/:customTableId',
    component: SupplierTablesDetailsPage,
    saga: initSupplierTablesDetailsPage,
    permissions: [isSupplier, hasProcessPermission],
  },
];
